// extracted by mini-css-extract-plugin
export default {"wrapper":"SearchBackendUsersPopup_wrapper__cxcvT","information":"SearchBackendUsersPopup_information__9MecD"};